import React, { Component } from 'react';
import { Container } from 'theme/Grid';
import DigitalNomadSubNav from 'components/navigation/DigitalNomadSubNav';
import SkillList from 'components/digitalNomad/SkillList';
import { WebSkills } from 'components/digitalNomad/MySkills'
import LatestWork from 'components/digitalNomad/LatestWork';

class DigitalNomadPage extends Component {

  render() {
    return (
      <Container className='digital-nomad-page'>
        <DigitalNomadSubNav />
        <SkillList skills={WebSkills} />
        <LatestWork />
      </Container>
    );
  }

}

export default DigitalNomadPage;



// WEBPACK FOOTER //
// ./src/containers/DigitalNomadPage.js